import joi, { ObjectSchema } from 'joi';
import { $expirationAttributes, ExpirationAttributes } from './expiration';
import { $uuid, dateSchema, localizedPropertySchema } from '../../utils';

export interface CurrencyI18nAttributes {
  description: string;
  image: string;
  name: string;
}

export interface CurrencyAttributes {
  id: string;
  programId?: string;
  i18nAttributes: CurrencyI18n;
  expiration: ExpirationAttributes;
  timezone: string;
  createdAt?: string;
  deletedAt?: string;
  updatedAt?: string;
}

export interface CurrencyI18n {
  [key: string]: CurrencyI18nAttributes;
}

export const $currencyI18n = localizedPropertySchema(
  joi.object<CurrencyI18nAttributes>({
    name: joi.string().min(0),
    description: joi.string().min(0),
    image: joi.string().min(0),
  }),
);

export interface CurrencyI18nAttributes {
  name: string;
  description: string;
  image: string;
}

export const $currencyAttributes = joi.object<CurrencyAttributes>({
  id: $uuid.optional(),
  i18nAttributes: $currencyI18n,
  expiration: $expirationAttributes,
  timezone: joi.string().optional().default('utc'),
  createdAt: dateSchema.optional().allow(null),
  deletedAt: dateSchema.optional().allow(null),
  updatedAt: dateSchema.optional().allow(null),
});

export const $setCurrencyBody: ObjectSchema<SetCurrencyBody> = $currencyAttributes.concat(
  joi.object({
    retroActive: joi.boolean().default(false),
    isNew: joi.boolean().optional().default(false),
  }),
) as any;

export interface SetCurrencyBody extends CurrencyAttributes {
  retroActive: boolean;
  isNew?: boolean;
}
